import { Outlet, createFileRoute } from '@tanstack/react-router'

// Layout cha cho nhóm route hộ trồng: /growers (index), /growers/new,
// /growers/$id/edit. Chỉ render Outlet để route con hiển thị.
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/growers',
)({
    component: () => <Outlet />,
})
